import WidgetAlphabetContainer from 'components/WidgetAlphabet/WidgetAlphabetContainer'
import WidgetAlphabetPresentation from 'components/WidgetAlphabet/WidgetAlphabetPresentation'
import WidgetAlphabetData from 'components/WidgetAlphabet/WidgetAlphabetData'

export default {
  Container: WidgetAlphabetContainer,
  Presentation: WidgetAlphabetPresentation,
  Data: WidgetAlphabetData,
}
